webpackJsonp([23899280101116],{

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_Component) {
	  _inherits(Project, _Component);
	
	  function Project() {
	    _classCallCheck(this, Project);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Project.prototype.toggleDetails = function toggleDetails(elem) {
	
	    var projectContainer = this.parent(elem.target),
	        activeProject = document.querySelector('.project.active');
	
	    if (projectContainer.classList.contains('active')) this.collapseDetails(projectContainer);else {
	      if (activeProject) this.collapseDetails(activeProject);
	
	      this.expandDetails(projectContainer);
	    }
	  };
	
	  Project.prototype.expandDetails = function expandDetails(element) {
	    var detailsContainer = element.querySelector('.details');
	
	    element.classList.add('active');
	    element.style.paddingBottom = detailsContainer.clientHeight + 'px';
	  };
	
	  Project.prototype.collapseDetails = function collapseDetails(element) {
	    element.classList.remove('active');
	    element.style.paddingBottom = '0px';
	  };
	
	  Project.prototype.parent = function parent(element) {
	    while (!element.classList.contains('project')) {
	      element = element.parentNode;
	    }
	
	    return element;
	  };
	
	  Project.prototype.render = function render() {
	    var data = this.props.data;
	    var frontmatter = data.frontmatter;
	    var html = data.html;
	
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'project' },
	      _react2.default.createElement(
	        'header',
	        { style: { 'backgroundImage': 'url(' + frontmatter.hero.publicURL + ')' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            frontmatter.title
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            frontmatter.overview
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'button',
	                { onClick: this.toggleDetails.bind(this) },
	                'Details'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              frontmatter.website && _react2.default.createElement(
	                'a',
	                { href: frontmatter.website },
	                'Website'
	              ),
	              !frontmatter.website && _react2.default.createElement(
	                'a',
	                { href: 'javascript:void(0)' },
	                'In development'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'details' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper story' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Project Details'
	            )
	          ),
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: html } }),
	          _react2.default.createElement(
	            'div',
	            null,
	            frontmatter.tags.length > 0 && _react2.default.createElement(
	              'div',
	              { className: 'tags' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Services'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'simple' },
	                frontmatter.tags.map(function (tag, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    tag
	                  );
	                })
	              )
	            ),
	            frontmatter.collaborators.length > 0 && _react2.default.createElement(
	              'div',
	              { className: 'tags' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Collaborators'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'simple' },
	                frontmatter.collaborators.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    item.website && _react2.default.createElement(
	                      'span',
	                      null,
	                      item.service,
	                      ' by',
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'a',
	                        { href: item.website },
	                        item.name
	                      )
	                    ),
	                    !item.website && _react2.default.createElement(
	                      'span',
	                      null,
	                      item.service,
	                      ' by',
	                      _react2.default.createElement('br', null),
	                      item.name
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Project;
	}(_react.Component);
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _project = __webpack_require__(44);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Work = function Work(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Some examples of my past work",
	      meta: [{
	        name: 'description', content: 'The portfolio of work of a freelance web developer and designer | Neil Rudd'
	      }],
	      bodyAttributes: { class: '__static' } }),
	    _react2.default.createElement(
	      "div",
	      { className: "white" },
	      data.allMarkdownRemark.edges.map(function (_ref2, index) {
	        var node = _ref2.node;
	        return _react2.default.createElement(_project2.default, { key: index, data: node });
	      })
	    )
	  );
	};
	
	exports.default = Work;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-js-bae9b2a401ffebdca831.js